<script setup>
defineProps({
  name: {
    type: String,
    default: 'arrow-right'
  },
  iconWidth: {
    type: String,
    default: ''
  }
})
</script>
<template>
  <span>
    <svg
      v-if="name ==='location'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1898_31885)">
        <path d="M13.8171 6.68444C13.8171 11.2902 7.89538 15.2381 7.89538 15.2381C7.89538 15.2381 1.97363 11.2902 1.97363 6.68444C1.97363 5.1139 2.59753 3.60768 3.70807 2.49713C4.81861 1.38659 6.32483 0.762695 7.89538 0.762695C9.46592 0.762695 10.9721 1.38659 12.0827 2.49713C13.1932 3.60768 13.8171 5.1139 13.8171 6.68444Z" stroke="#00A2CE" stroke-width="1.31594" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.89579 8.65779C8.98595 8.65779 9.86971 7.77404 9.86971 6.68388C9.86971 5.59371 8.98595 4.70996 7.89579 4.70996C6.80563 4.70996 5.92188 5.59371 5.92188 6.68388C5.92188 7.77404 6.80563 8.65779 7.89579 8.65779Z" stroke="#00A2CE" stroke-width="1.31594" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1898_31885">
          <rect width="15.7913" height="15.7913" fill="white" transform="translate(0 0.104492)" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="name ==='clock'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name ==='copy'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name ==='external'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path d="M18.5 13V19C18.5 19.5304 18.2893 20.0391 17.9142 20.4142C17.5391 20.7893 17.0304 21 16.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V8C3.5 7.46957 3.71071 6.96086 4.08579 6.58579C4.46086 6.21071 4.96957 6 5.5 6H11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.5 3H21.5V9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.5 14L21.5 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name ==='bed-alternative'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1898_31888)">
        <path d="M13.4788 8.22741V2.75798C13.4788 1.89493 12.7792 1.19531 11.9162 1.19531H5.66537C4.80232 1.19531 4.1027 1.89493 4.1027 2.75798V8.22741M13.4788 8.22741H4.1027M13.4788 8.22741C14.3419 8.22741 15.0415 8.92703 15.0415 9.79008V13.6969H2.54004V9.79008C2.54004 8.92703 3.23966 8.22741 4.1027 8.22741M2.54004 11.3528H15.0415M4.1027 15.2595V13.6969M13.4788 15.2595V13.6969M6.44674 5.10201H11.1348V8.22741H6.44674V5.10201Z" stroke="#00A2CE" stroke-width="1.31594" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1898_31888">
          <rect width="15.7913" height="15.7913" fill="white" transform="translate(0.791016 0.104492)" />
        </clipPath>
      </defs>
    </svg>
    <!-- eye -->
    <svg
      v-else-if="name === 'eye'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M0.75 9C0.75 9 3.75 3 9 3C14.25 3 17.25 9 17.25 9C17.25 9 14.25 15 9 15C3.75 15 0.75 9 0.75 9Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name === 'ruler'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1898_31891)">
        <path d="M15.572 4.38921L12.0896 0.90747C11.9914 0.809248 11.8749 0.731333 11.7465 0.678175C11.6182 0.625017 11.4807 0.597656 11.3418 0.597656C11.2029 0.597656 11.0654 0.625017 10.9371 0.678175C10.8088 0.731333 10.6922 0.809248 10.594 0.90747L1.38599 10.1148C1.28776 10.213 1.20985 10.3296 1.15669 10.4579C1.10353 10.5862 1.07617 10.7237 1.07617 10.8626C1.07617 11.0015 1.10353 11.139 1.15669 11.2674C1.20985 11.3957 1.28776 11.5123 1.38599 11.6105L4.86839 15.0922C4.96659 15.1904 5.08318 15.2683 5.21149 15.3215C5.3398 15.3747 5.47733 15.402 5.61622 15.402C5.75512 15.402 5.89264 15.3747 6.02096 15.3215C6.14927 15.2683 6.26586 15.1904 6.36406 15.0922L15.572 5.88488C15.6703 5.78668 15.7482 5.6701 15.8013 5.54178C15.8545 5.41347 15.8819 5.27594 15.8819 5.13705C15.8819 4.99816 15.8545 4.86063 15.8013 4.73231C15.7482 4.604 15.6703 4.48741 15.572 4.38921ZM5.61589 14.3447L2.13415 10.8623L4.24911 8.74734L5.98998 10.4889C6.0391 10.538 6.09742 10.577 6.16161 10.6036C6.22579 10.6301 6.29459 10.6438 6.36406 10.6438C6.43353 10.6438 6.50233 10.6301 6.56651 10.6036C6.6307 10.577 6.68902 10.538 6.73814 10.4889C6.78727 10.4398 6.82624 10.3814 6.85282 10.3172C6.87941 10.2531 6.89309 10.1843 6.89309 10.1148C6.89309 10.0453 6.87941 9.97653 6.85282 9.91234C6.82624 9.84816 6.78727 9.78984 6.73814 9.74071L4.99661 7.99984L6.36406 6.63239L8.10493 8.37392C8.20414 8.47313 8.33871 8.52887 8.47901 8.52887C8.61932 8.52887 8.75388 8.47313 8.8531 8.37392C8.95231 8.27471 9.00805 8.14015 9.00805 7.99984C9.00805 7.85953 8.95231 7.72497 8.8531 7.62575L7.11156 5.88488L8.47901 4.51743L10.2199 6.25897C10.269 6.30809 10.3273 6.34706 10.3915 6.37365C10.4557 6.40023 10.5245 6.41392 10.594 6.41392C10.6634 6.41392 10.7322 6.40023 10.7964 6.37365C10.8606 6.34706 10.9189 6.30809 10.9681 6.25897C11.0172 6.20984 11.0561 6.15152 11.0827 6.08734C11.1093 6.02315 11.123 5.95436 11.123 5.88488C11.123 5.81541 11.1093 5.74662 11.0827 5.68243C11.0561 5.61825 11.0172 5.55993 10.9681 5.5108L9.22652 3.76993L11.3415 1.65497L14.8239 5.13738L5.61589 14.3447Z" fill="#00A2CE" />
      </g>
      <defs>
        <clipPath id="clip0_1898_31891">
          <rect width="15.7913" height="15.7913" fill="white" transform="translate(0.583008 0.104492)" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'edit'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_1898_30503)">
        <path d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13.875 1.87517C14.1734 1.5768 14.578 1.40918 15 1.40918C15.422 1.40918 15.8266 1.5768 16.125 1.87517C16.4234 2.17354 16.591 2.57821 16.591 3.00017C16.591 3.42213 16.4234 3.8268 16.125 4.12517L9 11.2502L6 12.0002L6.75 9.00017L13.875 1.87517Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1898_30503">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'send'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 2L11 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'edit-3'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M9.99609 16.6641H17.4953" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.7449 2.91615C14.0764 2.58466 14.526 2.39844 14.9948 2.39844C15.2269 2.39844 15.4568 2.44416 15.6712 2.53299C15.8857 2.62182 16.0805 2.75202 16.2447 2.91615C16.4088 3.08029 16.539 3.27514 16.6278 3.4896C16.7167 3.70405 16.7624 3.9339 16.7624 4.16602C16.7624 4.39814 16.7167 4.62799 16.6278 4.84245C16.539 5.0569 16.4088 5.25175 16.2447 5.41589L5.82908 15.8315L2.49609 16.6647L3.32934 13.3317L13.7449 2.91615Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'tag'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M17.1587 11.1753L11.1837 17.1503C11.0289 17.3053 10.8451 17.4282 10.6427 17.5121C10.4404 17.596 10.2235 17.6391 10.0045 17.6391C9.78547 17.6391 9.56859 17.596 9.36626 17.5121C9.16393 17.4282 8.98011 17.3053 8.82533 17.1503L1.66699 10.0003V1.66699H10.0003L17.1587 8.82533C17.4691 9.1376 17.6433 9.56002 17.6433 10.0003C17.6433 10.4406 17.4691 10.8631 17.1587 11.1753V11.1753Z" stroke="#00A2CE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.83301 5.83301H5.84134" stroke="#00A2CE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'star'"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7957_46745)">
        <path d="M10.0863 11.6538C9.83422 11.8391 9.52239 11.7836 9.16685 11.5285L6.33519 9.49882L3.50642 11.5285C3.14667 11.7836 2.83769 11.8391 2.58276 11.6538C2.33617 11.471 2.282 11.1666 2.4238 10.7633L3.53936 7.51306L0.685388 5.51063C0.328341 5.26227 0.181549 4.98744 0.281173 4.6951C0.379464 4.40682 0.66075 4.26866 1.10121 4.26866H4.60302L5.6684 1.02258C5.80599 0.612741 6.02355 0.394775 6.33519 0.394775C6.64834 0.394775 6.86591 0.612741 7.00066 1.02258L8.06892 4.26866H11.5734C12.0112 4.26866 12.2896 4.40682 12.3879 4.69379C12.4917 4.98744 12.3407 5.26227 11.9865 5.51063L9.13254 7.51306L10.2481 10.7633C10.3871 11.1666 10.3329 11.471 10.0863 11.6538Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7957_46745">
          <rect width="12.6316" height="12" fill="white" transform="matrix(-1 0 0 1 12.6316 0)" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'instagram'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_1529_21623)">
        <path d="M9 1.6207C11.4047 1.6207 11.6895 1.63125 12.6352 1.67344C13.5141 1.71211 13.9887 1.85977 14.3051 1.98281C14.7234 2.14453 15.0258 2.34141 15.3387 2.6543C15.6551 2.9707 15.8484 3.26953 16.0102 3.68789C16.1332 4.0043 16.2809 4.48242 16.3195 5.35781C16.3617 6.30703 16.3723 6.5918 16.3723 8.99297C16.3723 11.3977 16.3617 11.6824 16.3195 12.6281C16.2809 13.507 16.1332 13.9816 16.0102 14.298C15.8484 14.7164 15.6516 15.0187 15.3387 15.3316C15.0223 15.648 14.7234 15.8414 14.3051 16.0031C13.9887 16.1262 13.5105 16.2738 12.6352 16.3125C11.6859 16.3547 11.4012 16.3652 9 16.3652C6.59531 16.3652 6.31055 16.3547 5.36484 16.3125C4.48594 16.2738 4.01133 16.1262 3.69492 16.0031C3.27656 15.8414 2.97422 15.6445 2.66133 15.3316C2.34492 15.0152 2.15156 14.7164 1.98984 14.298C1.8668 13.9816 1.71914 13.5035 1.68047 12.6281C1.63828 11.6789 1.62773 11.3941 1.62773 8.99297C1.62773 6.58828 1.63828 6.30351 1.68047 5.35781C1.71914 4.47891 1.8668 4.0043 1.98984 3.68789C2.15156 3.26953 2.34844 2.96719 2.66133 2.6543C2.97773 2.33789 3.27656 2.14453 3.69492 1.98281C4.01133 1.85977 4.48945 1.71211 5.36484 1.67344C6.31055 1.63125 6.59531 1.6207 9 1.6207ZM9 0C6.55664 0 6.25078 0.0105469 5.29102 0.0527344C4.33477 0.0949219 3.67734 0.249609 3.10781 0.471094C2.51367 0.703125 2.01094 1.00898 1.51172 1.51172C1.00898 2.01094 0.703125 2.51367 0.471094 3.1043C0.249609 3.67734 0.0949219 4.33125 0.0527344 5.2875C0.0105469 6.25078 0 6.55664 0 9C0 11.4434 0.0105469 11.7492 0.0527344 12.709C0.0949219 13.6652 0.249609 14.3227 0.471094 14.8922C0.703125 15.4863 1.00898 15.9891 1.51172 16.4883C2.01094 16.9875 2.51367 17.2969 3.1043 17.5254C3.67734 17.7469 4.33125 17.9016 5.2875 17.9437C6.24727 17.9859 6.55312 17.9965 8.99648 17.9965C11.4398 17.9965 11.7457 17.9859 12.7055 17.9437C13.6617 17.9016 14.3191 17.7469 14.8887 17.5254C15.4793 17.2969 15.982 16.9875 16.4813 16.4883C16.9805 15.9891 17.2898 15.4863 17.5184 14.8957C17.7398 14.3227 17.8945 13.6687 17.9367 12.7125C17.9789 11.7527 17.9895 11.4469 17.9895 9.00352C17.9895 6.56016 17.9789 6.2543 17.9367 5.29453C17.8945 4.33828 17.7398 3.68086 17.5184 3.11133C17.2969 2.51367 16.991 2.01094 16.4883 1.51172C15.9891 1.0125 15.4863 0.703125 14.8957 0.474609C14.3227 0.253125 13.6688 0.0984375 12.7125 0.05625C11.7492 0.0105469 11.4434 0 9 0Z" fill="currentColor" />
        <path d="M9 4.37695C6.44766 4.37695 4.37695 6.44766 4.37695 9C4.37695 11.5523 6.44766 13.623 9 13.623C11.5523 13.623 13.623 11.5523 13.623 9C13.623 6.44766 11.5523 4.37695 9 4.37695ZM9 11.9988C7.34414 11.9988 6.00117 10.6559 6.00117 9C6.00117 7.34414 7.34414 6.00117 9 6.00117C10.6559 6.00117 11.9988 7.34414 11.9988 9C11.9988 10.6559 10.6559 11.9988 9 11.9988Z" fill="currentColor" />
        <path d="M14.8852 4.19404C14.8852 4.7917 14.4 5.27334 13.8059 5.27334C13.2082 5.27334 12.7266 4.78819 12.7266 4.19404C12.7266 3.59639 13.2117 3.11475 13.8059 3.11475C14.4 3.11475 14.8852 3.5999 14.8852 4.19404Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_1529_21623">
          <rect width="18" height="18" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'back'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M9 14L4 9L9 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M20 20V13C20 11.9391 19.5786 10.9217 18.8284 10.1716C18.0783 9.42143 17.0609 9 16 9H4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'save'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path d="M19.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V5C3.5 4.46957 3.71071 3.96086 4.08579 3.58579C4.46086 3.21071 4.96957 3 5.5 3H16.5L21.5 8V19C21.5 19.5304 21.2893 20.0391 20.9142 20.4142C20.5391 20.7893 20.0304 21 19.5 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17.5 21V13H7.5V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.5 3V8H15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'trash'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path d="M2.25 4.5H3.75H15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5H14.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.5 8.25V12.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.5 8.25V12.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'facebook'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_1529_21620)">
        <path d="M9 0C4.02948 0 0 4.02948 0 9C0 13.2206 2.90592 16.7623 6.82596 17.735V11.7504H4.97016V9H6.82596V7.81488C6.82596 4.75164 8.21232 3.3318 11.2198 3.3318C11.79 3.3318 12.7739 3.44376 13.1764 3.55536V6.04836C12.964 6.02604 12.595 6.01488 12.1367 6.01488C10.661 6.01488 10.0908 6.57396 10.0908 8.02728V9H13.0306L12.5255 11.7504H10.0908V17.9341C14.5472 17.3959 18.0004 13.6015 18.0004 9C18 4.02948 13.9705 0 9 0Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_1529_21620">
          <rect width="18" height="18" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'info'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_335_6485)">
        <path
          d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 12V9"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 6H9.0075"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_335_6485">
          <rect
            width="18"
            height="18"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>

    <!-- Lock -->
    <svg
      v-else-if="name === 'lock'"
      :class="`rb-icon ${iconWidth}`"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.8333 9.1665H4.16667C3.24619 9.1665 2.5 9.9127 2.5 10.8332V16.6665C2.5 17.587 3.24619 18.3332 4.16667 18.3332H15.8333C16.7538 18.3332 17.5 17.587 17.5 16.6665V10.8332C17.5 9.9127 16.7538 9.1665 15.8333 9.1665Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.8335 9.1665V5.83317C5.8335 4.7281 6.27248 3.66829 7.05388 2.88689C7.83529 2.10549 8.89509 1.6665 10.0002 1.6665C11.1052 1.6665 12.165 2.10549 12.9464 2.88689C13.7278 3.66829 14.1668 4.7281 14.1668 5.83317V9.1665" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Unlocked -->
    <svg
      v-else-if="name === 'unlocked'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M7 10.9999V6.99991C6.99876 5.75996 7.45828 4.56378 8.28938 3.64358C9.12047 2.72338 10.2638 2.14481 11.4975 2.0202C12.7312 1.89558 13.9671 2.23381 14.9655 2.96922C15.9638 3.70463 16.6533 4.78476 16.9 5.99991"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- eye-off -->
    <svg
      v-else-if="name === 'eye-off'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_335_6670)">
        <path
          d="M10.59 10.59C10.384 10.8111 10.1356 10.9884 9.85961 11.1114C9.58362 11.2343 9.28568 11.3005 8.98357 11.3058C8.68146 11.3111 8.38137 11.2555 8.10121 11.1424C7.82104 11.0292 7.56654 10.8608 7.35288 10.6471C7.13923 10.4335 6.97079 10.179 6.85763 9.89881C6.74447 9.61865 6.68889 9.31856 6.69423 9.01645C6.69956 8.71434 6.76568 8.4164 6.88866 8.1404C7.01163 7.86441 7.18894 7.61601 7.41 7.41002M13.455 13.455C12.1729 14.4323 10.6118 14.9737 9 15C3.75 15 0.75 9.00002 0.75 9.00002C1.68292 7.26144 2.97685 5.74247 4.545 4.54502L13.455 13.455ZM7.425 3.18002C7.94125 3.05918 8.4698 2.99877 9 3.00002C14.25 3.00002 17.25 9.00002 17.25 9.00002C16.7947 9.85172 16.2518 10.6536 15.63 11.3925L7.425 3.18002Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 0.75L17.25 17.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_335_6670">
          <rect
            width="18"
            height="18"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>

    <!-- Arrow Right -->
    <svg
      v-else-if="name === 'arrow-right'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16L16 12L12 8"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12H16"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Arrow Left -->
    <svg
      v-if="name === 'arrow-left'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 8L8 12L12 16"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 12H8"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Email -->
    <svg
      v-else-if="name === 'email'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="38"
      viewBox="0 0 51 38"
      fill="none"
    >
      <path
        d="M6.3333 4.74999C5.46247 4.74999 4.74997 5.46249 4.74997 6.33332V8.5203L21.8202 22.5328C23.8686 24.2151 26.8077 24.2151 28.8561 22.5328L45.9164 8.5203V6.33332C45.9164 5.46249 45.2039 4.74999 44.3331 4.74999H6.3333ZM4.74997 14.6656V31.6666C4.74997 32.5374 5.46247 33.2499 6.3333 33.2499H44.3331C45.2039 33.2499 45.9164 32.5374 45.9164 31.6666V14.6656L31.8644 26.2041C28.0644 29.3213 22.5921 29.3213 18.802 26.2041L4.74997 14.6656ZM0 6.33332C0 2.8401 2.84009 0 6.3333 0H44.3331C47.8263 0 50.6664 2.8401 50.6664 6.33332V31.6666C50.6664 35.1598 47.8263 37.9999 44.3331 37.9999H6.3333C2.84009 37.9999 0 35.1598 0 31.6666V6.33332Z"
        fill="currentColor"
      />
    </svg>

    <!-- Email fill-->
    <svg
      v-else-if="name === 'email-fill'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path d="M53.7493 21.22V42.1875C53.7493 45.8119 50.8112 48.75 47.1868 48.75H12.8118C9.18745 48.75 6.24902 45.8119 6.24902 42.1875V21.22L29.2463 33.8691C29.7152 34.127 30.2834 34.127 30.7523 33.8691L53.7493 21.22ZM47.1868 11.25C50.7586 11.25 53.6639 14.1034 53.7475 17.6551L29.9993 30.7168L6.25152 17.655L6.25479 17.542C6.39665 14.0431 9.27805 11.25 12.8118 11.25H47.1868Z" fill="#00A2CE" />
    </svg>
    <svg
      v-else-if="name === 'email-responded'"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7169_7940)">
        <path d="M3 8H12.75H15C15.825 8 16.5 8.675 16.5 9.5V11.75V18.5C16.5 19.325 15.825 20 15 20H3C2.175 20 1.5 19.325 1.5 18.5V9.5C1.5 8.675 2.175 8 3 8Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.5 9.5L9 14.75L1.5 9.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.5 4L18.5 6L22.5 2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_7169_7940">
          <rect width="24" height="24" fill="currentColor" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>

    <!-- Menu -->
    <svg
      v-else-if="name === 'menu'"
      :class="`rb-icon ${iconWidth}`"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.96777 12H21.9678"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.96777 6H21.9678"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.96777 18H21.9678"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Speech Bubble -->
    <svg
      v-else-if="name === 'speech-bubble'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Submit -->
    <svg
      v-else-if="name === 'submit'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 2L11 13"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 2L15 22L11 13L2 9L22 2Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- User -->
    <svg
      v-else-if="name === 'user'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path d="M20.9678 21V19C20.9678 17.9391 20.5463 16.9217 19.7962 16.1716C19.0461 15.4214 18.0286 15 16.9678 15H8.96777C7.90691 15 6.88949 15.4214 6.13935 16.1716C5.3892 16.9217 4.96777 17.9391 4.96777 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.9678 11C15.1769 11 16.9678 9.20914 16.9678 7C16.9678 4.79086 15.1769 3 12.9678 3C10.7586 3 8.96777 4.79086 8.96777 7C8.96777 9.20914 10.7586 11 12.9678 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'question-mark'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18.1797 18.0002C18.6499 16.6635 19.578 15.5364 20.7996 14.8184C22.0212 14.1005 23.4575 13.838 24.854 14.0776C26.2506 14.3171 27.5173 15.0432 28.4298 16.1272C29.3424 17.2112 29.8418 18.5832 29.8397 20.0002C29.8397 24.0002 23.8397 26.0002 23.8397 26.0002" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M24 34H24.02" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'heart-light'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path d="M19.1017 4.22555C18.6335 3.75714 18.0776 3.38556 17.4657 3.13205C16.8539 2.87853 16.1981 2.74805 15.5358 2.74805C14.8735 2.74805 14.2177 2.87853 13.6059 3.13205C12.9941 3.38556 12.4382 3.75714 11.97 4.22555L10.9983 5.19722L10.0267 4.22555C9.08093 3.27984 7.79827 2.74854 6.46082 2.74854C5.12337 2.74854 3.8407 3.27984 2.89499 4.22555C1.94927 5.17127 1.41797 6.45394 1.41797 7.79139C1.41797 9.12883 1.94927 10.4115 2.89499 11.3572L3.86665 12.3289L10.9983 19.4606L18.13 12.3289L19.1017 11.3572C19.5701 10.889 19.9416 10.3331 20.1952 9.7213C20.4487 9.10946 20.5792 8.45367 20.5792 7.79139C20.5792 7.12911 20.4487 6.47332 20.1952 5.86148C19.9416 5.24964 19.5701 4.69375 19.1017 4.22555V4.22555Z" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'light'"
      :class="`rb-icon ${iconWidth}`"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.81261 14.2916L6.81258 14.2916C6.00311 13.6615 5.34753 12.8556 4.89547 11.9348C4.44341 11.014 4.2067 10.0024 4.20325 8.97662L4.25012 8.97647L4.20325 8.97672C4.18343 5.29498 7.15403 2.2299 10.8359 2.14303C10.8359 2.14303 10.8359 2.14303 10.8359 2.14303L10.837 2.1899L6.81261 14.2916ZM6.81261 14.2916C7.16831 14.5681 7.45604 14.9224 7.65374 15.3272C7.85145 15.7321 7.9539 16.1768 7.95325 16.6273V16.6274M6.81261 14.2916L7.95325 16.6274M7.95325 16.6274V17.1899V17.2368M7.95325 16.6274V17.2368M7.95325 17.2368H8.00013M7.95325 17.2368H8.00013M8.00013 17.2368H14.0001H14.047M8.00013 17.2368H14.047M14.047 17.2368V17.1899M14.047 17.2368V17.1899M14.047 17.1899V16.6275C14.048 16.1757 14.1522 15.73 14.3517 15.3245C14.5512 14.9191 14.8406 14.5645 15.1979 14.2879L15.1981 14.2878M14.047 17.1899L15.1981 14.2878M15.1981 14.2878C16.01 13.6532 16.6663 12.8415 17.1167 11.9147M15.1981 14.2878L17.1167 11.9147M17.1167 11.9147C17.5671 10.9878 17.7998 9.97028 17.797 8.93978M17.1167 11.9147L17.797 8.93978M17.797 8.93978L17.7501 8.9399L17.797 8.93978ZM16.1937 8.07241C16.0009 6.9956 15.4828 6.00371 14.7092 5.23027C13.9356 4.45684 12.9436 3.93898 11.8668 3.74639C11.7758 3.73109 11.6827 3.73384 11.5928 3.75449C11.5027 3.77515 11.4177 3.81335 11.3424 3.86689C11.2672 3.92043 11.2032 3.98826 11.1542 4.06652C11.1052 4.14478 11.072 4.23194 11.0567 4.323C11.0413 4.41407 11.0441 4.50727 11.0647 4.59728C11.0854 4.68729 11.1236 4.77235 11.1771 4.8476C11.2307 4.92284 11.2985 4.98681 11.3768 5.03584C11.455 5.08488 11.5422 5.11801 11.6332 5.13336C13.2064 5.39825 14.5399 6.7318 14.8067 8.30768L16.1937 8.07241ZM16.1937 8.07241C16.2249 8.25612 16.1819 8.44473 16.0742 8.59679C15.9664 8.74885 15.8028 8.85191 15.6191 8.88334C15.5797 8.88954 15.5399 8.89278 15.5 8.89303C15.3339 8.89307 15.1732 8.83432 15.0463 8.7272C14.9194 8.62006 14.8345 8.47145 14.8067 8.3077L16.1937 8.07241ZM19.2033 8.93989V8.94003C19.2065 10.1832 18.9256 11.4106 18.3822 12.5287C17.8388 13.6467 17.0471 14.6258 16.0676 15.3913C15.8779 15.5368 15.7239 15.7238 15.6174 15.9379C15.5109 16.1522 15.4547 16.3879 15.4533 16.6271V16.6274V17.1899C15.4533 17.5753 15.3002 17.9449 15.0276 18.2174C14.7551 18.4899 14.3855 18.643 14.0001 18.643H8.00013C7.61474 18.643 7.24513 18.4899 6.97261 18.2174C6.7001 17.9449 6.547 17.5753 6.547 17.1899V16.6274V16.6274C6.54684 16.3909 6.49247 16.1576 6.38805 15.9454C6.28365 15.7333 6.13199 15.5479 5.94474 15.4035C4.96772 14.6425 4.1766 13.6693 3.63125 12.5574C3.08588 11.4455 2.8006 10.2241 2.797 8.9857L2.797 8.98559C2.77276 4.54298 6.36369 0.843019 10.8025 0.736756L10.8025 0.736756C11.8963 0.710398 12.9843 0.903105 14.0024 1.30353C15.0206 1.70396 15.9484 2.30402 16.7312 3.0684C17.514 3.83277 18.1359 4.74601 18.5605 5.75436C18.985 6.76271 19.2036 7.84581 19.2033 8.93989ZM15.4533 20.9399C15.4533 21.1264 15.3792 21.3052 15.2473 21.4371C15.1155 21.569 14.9366 21.643 14.7501 21.643H7.25013C7.06365 21.643 6.8848 21.569 6.75294 21.4371C6.62108 21.3052 6.547 21.1264 6.547 20.9399C6.547 20.7534 6.62108 20.5746 6.75294 20.4427C6.8848 20.3109 7.06365 20.2368 7.25013 20.2368H14.7501C14.9366 20.2368 15.1155 20.3109 15.2473 20.4427C15.3792 20.5746 15.4533 20.7534 15.4533 20.9399Z" fill="currentColor" stroke="currentColor" stroke-width="0.0937501" />
    </svg>

    <!-- Whatsapp -->
    <svg
      v-else-if="name === 'whatsapp'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="48"
      viewBox="0 0 42 48"
      fill="none"
    >
      <g clip-path="url(#clip0_197_5821)">
        <path
          d="M35.7094 9.10312C31.7812 5.16562 26.55 3 20.9906 3C9.51562 3 0.178125 12.3375 0.178125 23.8125C0.178125 27.4781 1.13438 31.0594 2.95312 34.2188L0 45L11.0344 42.1031C14.0719 43.7625 17.4937 44.6344 20.9813 44.6344H20.9906C32.4562 44.6344 42 35.2969 42 23.8219C42 18.2625 39.6375 13.0406 35.7094 9.10312ZM20.9906 41.1281C17.8781 41.1281 14.8312 40.2938 12.1781 38.7188L11.55 38.3438L5.00625 40.0594L6.75 33.675L6.3375 33.0188C4.60312 30.2625 3.69375 27.0844 3.69375 23.8125C3.69375 14.2781 11.4562 6.51562 21 6.51562C25.6219 6.51562 29.9625 8.31562 33.225 11.5875C36.4875 14.8594 38.4938 19.2 38.4844 23.8219C38.4844 33.3656 30.525 41.1281 20.9906 41.1281ZM30.4781 28.1719C29.9625 27.9094 27.4031 26.6531 26.925 26.4844C26.4469 26.3062 26.1 26.2219 25.7531 26.7469C25.4063 27.2719 24.4125 28.4344 24.1031 28.7906C23.8031 29.1375 23.4938 29.1844 22.9781 28.9219C19.9219 27.3937 17.9156 26.1938 15.9 22.7344C15.3656 21.8156 16.4344 21.8813 17.4281 19.8937C17.5969 19.5469 17.5125 19.2469 17.3812 18.9844C17.25 18.7219 16.2094 16.1625 15.7781 15.1219C15.3563 14.1094 14.925 14.25 14.6063 14.2313C14.3063 14.2125 13.9594 14.2125 13.6125 14.2125C13.2656 14.2125 12.7031 14.3438 12.225 14.8594C11.7469 15.3844 10.4062 16.6406 10.4062 19.2C10.4062 21.7594 12.2719 24.2344 12.525 24.5813C12.7875 24.9281 16.1906 30.1781 21.4125 32.4375C24.7125 33.8625 26.0063 33.9844 27.6562 33.7406C28.6594 33.5906 30.7312 32.4844 31.1625 31.2656C31.5938 30.0469 31.5938 29.0063 31.4625 28.7906C31.3406 28.5563 30.9938 28.425 30.4781 28.1719Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_197_5821">
          <rect
            width="42"
            height="48"
            fill="currentColor"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'house-light'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path d="M2.75 8.25016L11 1.8335L19.25 8.25016V18.3335C19.25 18.8197 19.0568 19.286 18.713 19.6299C18.3692 19.9737 17.9029 20.1668 17.4167 20.1668H4.58333C4.0971 20.1668 3.63079 19.9737 3.28697 19.6299C2.94315 19.286 2.75 18.8197 2.75 18.3335V8.25016Z" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.25 20.1667V11H13.75V20.1667" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'sliders'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path d="M3.66797 19.2502V12.8335" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.66797 9.16667V2.75" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11 19.25V11" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11 7.33333V2.75" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18.332 19.2498V14.6665" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18.332 11V2.75" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M0.917969 12.8335H6.41797" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.25 7.3335H13.75" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.582 14.6665H21.082" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'creditcard'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path d="M19.2513 3.6665H2.7513C1.73878 3.6665 0.917969 4.48732 0.917969 5.49984V16.4998C0.917969 17.5124 1.73878 18.3332 2.7513 18.3332H19.2513C20.2638 18.3332 21.0846 17.5124 21.0846 16.4998V5.49984C21.0846 4.48732 20.2638 3.6665 19.2513 3.6665Z" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M0.917969 9.1665H21.0846" stroke="currentColor" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Cross -->
    <svg
      v-else-if="name === 'cross'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 6L6 18"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Bell -->
    <svg
      v-else-if="name === 'bell'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M20.0856 2.59403C20.1389 2.47399 20.2154 2.36563 20.3106 2.27513C20.4057 2.18464 20.5178 2.11378 20.6404 2.06661C20.763 2.01943 20.8937 1.99687 21.025 2.0002C21.1563 2.00353 21.2856 2.0327 21.4056 2.08603C21.6376 2.19003 25.3616 3.96403 27.8596 8.14603C29.1216 10.266 29.6536 12.436 29.8716 14.092C29.9962 15.042 30.0396 16.0007 30.0016 16.958V17.01V17.002C30.0016 17.2673 29.8963 17.5216 29.7087 17.7091C29.5212 17.8967 29.2669 18.002 29.0016 18.002C28.7364 18.002 28.4821 17.8967 28.2945 17.7091C28.107 17.5216 28.0016 17.2673 28.0016 17.002V16.902C28.0316 16.216 28.1816 12.59 26.1416 9.17203C24.9149 7.13633 23.2042 5.43526 21.1616 4.22003C20.8196 4.02003 20.6096 3.92003 20.5936 3.91403C20.4736 3.86073 20.3652 3.7843 20.2747 3.68911C20.1842 3.59392 20.1134 3.48184 20.0662 3.35926C20.019 3.23668 19.9965 3.10601 19.9998 2.97471C20.0031 2.84341 20.0323 2.71406 20.0856 2.59403ZM20.1896 7.42003C20.3451 7.20526 20.5795 7.06102 20.8413 7.01901C21.103 6.97701 21.3708 7.04068 21.5856 7.19603C21.5796 7.19203 22.0576 7.49203 22.6256 8.01603C23.1996 8.54003 23.9056 9.32203 24.4696 10.37C25.084 11.5193 25.4473 12.7859 25.5356 14.086C25.5436 14.206 25.5456 14.3 25.5476 14.374V14.5C25.5476 14.7652 25.4423 15.0196 25.2547 15.2071C25.0672 15.3947 24.8129 15.5 24.5476 15.5C24.2824 15.5 24.0281 15.3947 23.8405 15.2071C23.653 15.0196 23.5476 14.7652 23.5476 14.5V14.494C23.5257 13.3642 23.2289 12.2568 22.6829 11.2674C22.1368 10.2781 21.3579 9.43671 20.4136 8.81603C20.1989 8.66057 20.0546 8.42619 20.0126 8.16441C19.9706 7.90263 20.0343 7.63488 20.1896 7.42003ZM5.07364 21.414C4.05329 19.5793 3.79504 17.417 4.3546 15.3936C4.91415 13.3702 6.24665 11.6478 8.06468 10.5979C9.88271 9.54812 12.0406 9.25501 14.0727 9.78183C16.1049 10.3087 17.8486 11.6132 18.9276 13.414L20.5676 16.254L24.3796 19.028C24.5142 19.1261 24.6222 19.2561 24.6938 19.4065C24.7654 19.5568 24.7983 19.7226 24.7896 19.8889C24.7808 20.0552 24.7307 20.2166 24.6438 20.3586C24.5568 20.5006 24.4358 20.6187 24.2916 20.702L19.2316 23.622L19.2396 23.628L13.7636 26.788V26.782L8.70364 29.702C8.55936 29.7857 8.39646 29.8319 8.22976 29.8365C8.06306 29.8411 7.89785 29.804 7.74917 29.7284C7.60049 29.6529 7.47306 29.5414 7.37848 29.4041C7.2839 29.2667 7.22517 29.1079 7.20764 28.942L6.71364 24.256L5.07364 21.414ZM20.4996 25.21L14.5036 28.67C15.0257 29.3261 15.7658 29.7729 16.5895 29.9293C17.4131 30.0857 18.2655 29.9412 18.9917 29.5222C19.7178 29.1032 20.2694 28.4374 20.5462 27.6461C20.8229 26.8547 20.8064 25.9903 20.4996 25.21Z"
        fill="currentColor"
      />
    </svg>
    <!-- bell alert -->
    <svg
      v-else-if="name === 'bell-alert'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g>
        <path
          id="Vector"
          d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M13.7295 21C13.5537 21.3031 13.3014 21.5547 12.9978 21.7295C12.6941 21.9044 12.3499 21.9965 11.9995 21.9965C11.6492 21.9965 11.3049 21.9044 11.0013 21.7295C10.6977 21.5547 10.4453 21.3031 10.2695 21"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>

    <!-- Dartboard -->
    <svg
      v-else-if="name === 'dartboard'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M23.9998 2.99996C24.0001 2.80192 23.9417 2.60823 23.8318 2.44345C23.722 2.27867 23.5656 2.15022 23.3827 2.07439C23.1998 1.99855 22.9984 1.97875 22.8042 2.01748C22.61 2.05622 22.4316 2.15174 22.2918 2.29196L18.2918 6.29196C18.199 6.385 18.1254 6.49541 18.0753 6.6169C18.0252 6.73838 17.9995 6.86855 17.9998 6.99996V12.586L16.5178 14.066C16.2213 13.9873 15.9107 13.9777 15.61 14.038C15.3092 14.0983 15.0263 14.2268 14.7831 14.4136C14.5398 14.6004 14.3427 14.8406 14.2069 15.1157C14.0711 15.3907 14.0002 15.6932 13.9998 16C13.9999 16.2846 14.0608 16.5659 14.1783 16.8251C14.2959 17.0843 14.4674 17.3155 14.6815 17.5031C14.8955 17.6907 15.1472 17.8305 15.4195 17.913C15.6919 17.9956 15.9788 18.0191 16.261 17.9819C16.5432 17.9447 16.8142 17.8478 17.0559 17.6975C17.2976 17.5472 17.5044 17.347 17.6626 17.1103C17.8208 16.8737 17.9266 16.606 17.973 16.3252C18.0194 16.0444 18.0054 15.7569 17.9318 15.482L19.4138 14H24.9998C25.1312 14.0002 25.2614 13.9745 25.3828 13.9244C25.5043 13.8743 25.6147 13.8008 25.7078 13.708L29.7078 9.70796C29.848 9.5681 29.9435 9.38976 29.9823 9.19554C30.021 9.00132 30.0012 8.79998 29.9253 8.61703C29.8495 8.43408 29.7211 8.27777 29.5563 8.16792C29.3915 8.05806 29.1978 7.9996 28.9998 7.99996H23.9998V2.99996ZM27.8878 14.356C28.2319 16.8463 27.7852 19.3818 26.6108 21.6046C25.4363 23.8274 23.5934 25.6253 21.3422 26.7443C19.091 27.8633 16.5452 28.2471 14.0641 27.8414C11.5831 27.4357 9.29213 26.261 7.51463 24.4831C5.73714 22.7053 4.5629 20.4141 4.15766 17.933C3.75243 15.4518 4.13668 12.9061 5.25616 10.6551C6.37564 8.40409 8.17381 6.56154 10.3969 5.38752C12.6199 4.21351 15.1555 3.76732 17.6458 4.11196L16.8798 4.87796C16.6009 5.15651 16.3796 5.48729 16.2286 5.85139C16.0776 6.21549 15.9999 6.60579 15.9998 6.99996C14.2197 6.99996 12.4797 7.5278 10.9996 8.51673C9.5196 9.50566 8.36605 10.9113 7.68486 12.5558C7.00367 14.2003 6.82544 16.0099 7.17271 17.7558C7.51997 19.5016 8.37714 21.1052 9.63581 22.3639C10.8945 23.6226 12.4981 24.4798 14.244 24.827C15.9898 25.1743 17.7994 24.9961 19.4439 24.3149C21.0885 23.6337 22.4941 22.4801 23.483 21.0001C24.4719 19.52 24.9998 17.78 24.9998 16C25.7952 15.9993 26.5577 15.6827 27.1198 15.12L27.8878 14.356ZM15.9998 8.99996C14.6153 8.99996 13.2619 9.4105 12.1108 10.1797C10.9596 10.9488 10.0624 12.0421 9.53262 13.3212C9.0028 14.6003 8.86418 16.0077 9.13428 17.3656C9.40437 18.7235 10.0711 19.9707 11.05 20.9497C12.029 21.9287 13.2763 22.5954 14.6341 22.8655C15.992 23.1356 17.3995 22.9969 18.6786 22.4671C19.9576 21.9373 21.0509 21.0401 21.8201 19.889C22.5892 18.7378 22.9998 17.3844 22.9998 16H20.2418L19.9918 16.25C19.9437 17.0183 19.6749 17.7565 19.2177 18.3758C18.7605 18.9952 18.1342 19.4694 17.4141 19.7417C16.694 20.0139 15.9106 20.0726 15.158 19.9106C14.4054 19.7487 13.7155 19.3729 13.1712 18.8286C12.6268 18.2842 12.2511 17.5943 12.0891 16.8417C11.9271 16.0891 11.9858 15.3057 12.258 14.5856C12.5303 13.8655 13.0046 13.2393 13.6239 12.782C14.2433 12.3248 14.9814 12.056 15.7498 12.008L15.9998 11.758V8.99996Z"
        fill="currentColor"
      />
    </svg>

    <!-- House-search -->
    <svg
      v-else-if="name === 'house-search'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M25.7463 25.2C26.3329 24.28 26.6663 23.1733 26.6663 22C26.6663 18.6667 23.9996 16 20.6663 16C17.3329 16 14.6663 18.6667 14.6663 22C14.6663 25.3333 17.3329 28 20.6663 28C21.8263 28 22.9196 27.6667 23.8396 27.0933L27.9996 31.1867L29.8529 29.3333L25.7463 25.2ZM20.6663 25.3333C19.7822 25.3333 18.9344 24.9821 18.3092 24.357C17.6841 23.7319 17.3329 22.8841 17.3329 22C17.3329 21.1159 17.6841 20.2681 18.3092 19.643C18.9344 19.0179 19.7822 18.6667 20.6663 18.6667C21.5503 18.6667 22.3982 19.0179 23.0233 19.643C23.6484 20.2681 23.9996 21.1159 23.9996 22C23.9996 22.8841 23.6484 23.7319 23.0233 24.357C22.3982 24.9821 21.5503 25.3333 20.6663 25.3333ZM6.66626 26.6667V16H2.66626L15.9996 4L29.3329 16H26.9063C25.3329 14.36 23.1196 13.3333 20.6663 13.3333C15.8929 13.3333 11.9996 17.2267 11.9996 22C11.9996 23.72 12.5063 25.3333 13.3729 26.6667H6.66626Z"
        fill="currentColor"
      />
    </svg>

    <!-- Heart -->
    <svg
      v-else-if="name === 'heart'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.8435 8.86252C28.4246 7.89263 27.8207 7.01373 27.0654 6.27502C26.3095 5.5341 25.4184 4.9453 24.4404 4.54065C23.4262 4.11938 22.3385 3.90374 21.2404 3.90627C19.6998 3.90627 18.1966 4.32815 16.8904 5.12502C16.5779 5.31565 16.281 5.52502 15.9998 5.75314C15.7185 5.52502 15.4216 5.31565 15.1091 5.12502C13.8029 4.32815 12.2998 3.90627 10.7591 3.90627C9.64976 3.90627 8.57476 4.11877 7.55913 4.54065C6.57788 4.9469 5.69351 5.53127 4.93413 6.27502C4.17787 7.0129 3.57375 7.89201 3.15601 8.86252C2.72163 9.87189 2.49976 10.9438 2.49976 12.0469C2.49976 13.0875 2.71226 14.1719 3.13413 15.275C3.48726 16.1969 3.99351 17.1531 4.64038 18.1188C5.66538 19.6469 7.07476 21.2406 8.82476 22.8563C11.7248 25.5344 14.5966 27.3844 14.7185 27.4594L15.4591 27.9344C15.7873 28.1437 16.2091 28.1437 16.5373 27.9344L17.2779 27.4594C17.3998 27.3812 20.2685 25.5344 23.1716 22.8563C24.9216 21.2406 26.331 19.6469 27.356 18.1188C28.0029 17.1531 28.5123 16.1969 28.8623 15.275C29.2841 14.1719 29.4966 13.0875 29.4966 12.0469C29.4998 10.9438 29.2779 9.87189 28.8435 8.86252Z"
        fill="currentColor"
      />
    </svg>

    <!-- Arrow down -->
    <svg
      v-else-if="name === 'arrow-down-simple'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M10 4.16797V15.8346" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.8327 10L9.99935 15.8333L4.16602 10" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'filter'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Arrow up -->
    <svg
      v-else-if="name === 'arrow-up-simple'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M10 15.8332V4.1665" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.16797 9.99984L10.0013 4.1665L15.8346 9.99984" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'arrow-down-left'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M9 10L4 15L9 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M20 4V11C20 12.0609 19.5786 13.0783 18.8284 13.8284C18.0783 14.5786 17.0609 15 16 15H4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'upload'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'arrow-up'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16 12L12 8L8 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 16V8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'arrow-up-left'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M9 14L4 9L9 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M20 20V13C20 11.9391 19.5786 10.9217 18.8284 10.1716C18.0783 9.42143 17.0609 9 16 9H4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Arrow outline left -->
    <svg
      v-else-if="name === 'arrow-outline-left'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 12H5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 19L5 12L12 5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Arrow outline right -->
    <svg
      v-else-if="name === 'arrow-outline-right'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 12H19"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 5L19 12L12 19"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'dot-yellow'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="7" cy="7" r="6.5" fill="#FFAD33" stroke="url(#paint0_linear_2568_35410)" />
      <defs>
        <linearGradient
          id="paint0_linear_2568_35410"
          x1="7"
          y1="0"
          x2="7"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFC877" />
          <stop offset="1" stop-color="#FAE0BA" />
        </linearGradient>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'dot-green'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="7" cy="7" r="6.5" fill="#0FBA80" stroke="url(#paint0_linear_2568_45167)" />
      <defs>
        <linearGradient
          id="paint0_linear_2568_45167"
          x1="7"
          y1="0"
          x2="7"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7AE0BF" />
          <stop offset="1" stop-color="#8FEBCD" />
        </linearGradient>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'dot-red'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="7" cy="7" r="6.5" fill="#EF4444" stroke="url(#paint0_linear_2568_42876)" />
      <defs>
        <linearGradient
          id="paint0_linear_2568_42876"
          x1="7"
          y1="0"
          x2="7"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F78B8B" />
          <stop offset="1" stop-color="#F0C7C7" />
        </linearGradient>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'dot-gray'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="7" cy="7" r="6.5" fill="#6B7280" stroke="url(#paint0_linear_2568_42876)" />
      <defs>
        <linearGradient
          id="paint0_linear_2568_42876a"
          x1="7"
          y1="0"
          x2="7"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9CA3AF" />
          <stop offset="1" stop-color="#D1D5DB" />
        </linearGradient>
      </defs>
    </svg>
    <!-- Caret down-->
    <svg
      v-else-if="name === 'caret-down'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M8 12L16 20L24 12"
        stroke="currentColor"
        stroke-width="2.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- House -->
    <svg
      v-else-if="name === 'house'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
    >
      <g clip-path="url(#clip0_197_4811)">
        <path
          d="M11.682 6.17085L3.99989 12.4911V19.3125C3.99989 19.4891 4.07013 19.6585 4.19515 19.7834C4.32018 19.9083 4.48975 19.9785 4.66656 19.9785L9.33572 19.9664C9.51196 19.9655 9.68067 19.895 9.80498 19.7702C9.92928 19.6454 9.99906 19.4765 9.99906 19.3004V15.3168C9.99906 15.1402 10.0693 14.9708 10.1943 14.8459C10.3193 14.721 10.4889 14.6509 10.6657 14.6509H13.3324C13.5092 14.6509 13.6788 14.721 13.8038 14.8459C13.9288 14.9708 13.9991 15.1402 13.9991 15.3168V19.2975C13.9988 19.3852 14.0158 19.472 14.0492 19.553C14.0826 19.634 14.1316 19.7077 14.1936 19.7698C14.2555 19.8318 14.3291 19.8811 14.4101 19.9147C14.4911 19.9483 14.578 19.9656 14.6657 19.9656L19.3332 19.9785C19.51 19.9785 19.6796 19.9083 19.8046 19.7834C19.9297 19.6585 19.9999 19.4891 19.9999 19.3125V12.4865L12.3195 6.17085C12.2292 6.09815 12.1167 6.0585 12.0007 6.0585C11.8847 6.0585 11.7723 6.09815 11.682 6.17085ZM23.8166 10.4666L20.3332 7.59848V1.83345C20.3332 1.70098 20.2805 1.57394 20.1868 1.48027C20.093 1.38661 19.9658 1.33398 19.8332 1.33398H17.4999C17.3673 1.33398 17.2401 1.38661 17.1463 1.48027C17.0526 1.57394 16.9999 1.70098 16.9999 1.83345V4.8556L13.2695 1.78974C12.9115 1.49547 12.4623 1.33457 11.9986 1.33457C11.535 1.33457 11.0858 1.49547 10.7278 1.78974L0.180725 10.4666C0.130095 10.5084 0.0882067 10.5598 0.0574534 10.6178C0.0267 10.6758 0.00768456 10.7392 0.00149348 10.8045C-0.00469761 10.8699 0.00205702 10.9358 0.0213714 10.9985C0.0406858 11.0612 0.0721814 11.1195 0.114059 11.17L1.17656 12.4603C1.21832 12.511 1.26969 12.553 1.32772 12.5839C1.38576 12.6148 1.44932 12.6339 1.51476 12.6402C1.58021 12.6465 1.64626 12.6399 1.70913 12.6206C1.77199 12.6014 1.83045 12.57 1.88114 12.5282L11.682 4.46436C11.7723 4.39165 11.8847 4.35201 12.0007 4.35201C12.1167 4.35201 12.2292 4.39165 12.3195 4.46436L22.1207 12.5282C22.1713 12.57 22.2297 12.6015 22.2925 12.6207C22.3553 12.64 22.4212 12.6468 22.4866 12.6406C22.552 12.6344 22.6155 12.6154 22.6736 12.5847C22.7316 12.554 22.783 12.5121 22.8249 12.4616L23.8874 11.1713C23.9292 11.1204 23.9606 11.0618 23.9797 10.9989C23.9988 10.9359 24.0052 10.8697 23.9986 10.8043C23.992 10.7388 23.9726 10.6752 23.9413 10.6173C23.9101 10.5594 23.8677 10.5082 23.8166 10.4666Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_197_4811">
          <rect
            width="24"
            height="21.3103"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>

    <!-- Bed -->
    <svg
      v-else-if="name === `bed`"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
    >
      <g clip-path="url(#clip0_197_4815)">
        <path
          d="M8.25027 12C10.3179 12 12.0003 10.3177 12.0003 8.25001C12.0003 6.18235 10.3179 4.5 8.25027 4.5C6.1826 4.5 4.50026 6.18235 4.50026 8.25001C4.50026 10.3177 6.1826 12 8.25027 12ZM24.7503 6.00001H14.2503C13.8359 6.00001 13.5003 6.33563 13.5003 6.75001V13.5H3.00025V3.75C3.00025 3.33563 2.66463 3 2.25025 3H0.750246C0.33587 3 0.000244141 3.33563 0.000244141 3.75V20.25C0.000244141 20.6644 0.33587 21 0.750246 21H2.25025C2.66463 21 3.00025 20.6644 3.00025 20.25V18H27.0003V20.25C27.0003 20.6644 27.3359 21 27.7503 21H29.2503C29.6647 21 30.0003 20.6644 30.0003 20.25V11.25C30.0003 8.35033 27.65 6.00001 24.7503 6.00001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_197_4815">
          <rect
            width="30.0001"
            height="24.0001"
            fill="currentColor"
          />
        </clipPath>
      </defs>
    </svg>

    <!-- Search -->
    <svg
      v-else-if="name === 'search'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.9999 20.9999L16.6499 16.6499"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!--    Search slim-->

    <svg
      v-else-if="name === 'search-slim'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path d="M24.6418 4.28482C35.8848 4.28482 44.999 13.399 44.999 24.642C44.999 29.1033 43.5639 33.2294 41.1301 36.5838L54.7718 50.2263C56.0271 51.4815 56.0271 53.5167 54.7718 54.772C53.595 55.9488 51.7327 56.0223 50.4702 54.9926L50.2261 54.772L36.5837 41.1303C33.2292 43.564 29.1031 44.9991 24.6418 44.9991C13.3989 44.9991 4.28467 35.8849 4.28467 24.642C4.28467 13.399 13.3989 4.28482 24.6418 4.28482ZM24.6418 10.7134C16.9493 10.7134 10.7132 16.9494 10.7132 24.642C10.7132 32.3345 16.9493 38.5705 24.6418 38.5705C32.3344 38.5705 38.5704 32.3345 38.5704 24.642C38.5704 16.9494 32.3344 10.7134 24.6418 10.7134Z" fill="#00A2CE" />
    </svg>

    <!--    Search buddy-->
    <svg
      v-else-if="name === 'search-buddy'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path d="M43.75 30C51.3439 30 57.5 36.1561 57.5 43.75C57.5 51.3439 51.3439 57.5 43.75 57.5C36.1561 57.5 30 51.3439 30 43.75C30 36.1561 36.1561 30 43.75 30ZM10 32.4975L32.0235 32.5005C29.2218 35.4202 27.5 39.384 27.5 43.75C27.5 46.4684 28.1675 49.0309 29.3475 51.2826C26.7218 52.1575 23.8264 52.5 21.25 52.5C14.4447 52.5 5.41174 50.1099 5.01364 41.8241L5 41.25V37.4975C5 34.7375 7.24 32.4975 10 32.4975ZM43.75 35.004L43.5253 35.0241C43.0151 35.1167 42.6128 35.5191 42.5201 36.0293L42.5 36.254V42.499L36.25 42.5L36.0253 42.5202C35.5151 42.6128 35.1127 43.0151 35.0201 43.5253L35 43.75L35.0201 43.9747C35.1127 44.485 35.5151 44.8873 36.0253 44.9799L36.25 45L42.5 44.999V51.25L42.5201 51.4747C42.6128 51.985 43.0151 52.3873 43.5253 52.4799L43.75 52.5L43.9747 52.4799C44.4849 52.3873 44.8872 51.985 44.9799 51.4747L45 51.25V44.999L51.25 45L51.4747 44.9799C51.9849 44.8873 52.3872 44.485 52.4799 43.9747L52.5 43.75L52.4799 43.5253C52.3872 43.0151 51.9849 42.6128 51.4747 42.5202L51.25 42.5L45 42.499V36.254L44.9799 36.0293C44.8872 35.5191 44.4849 35.1167 43.9747 35.0241L43.75 35.004ZM21.25 5.00003C27.4625 5.00003 32.5 10.0375 32.5 16.25C32.5 22.4625 27.4625 27.5 21.25 27.5C15.0375 27.5 10 22.4625 10 16.25C10 10.0375 15.0375 5.00003 21.25 5.00003ZM43.75 10C48.5825 10 52.5 13.9175 52.5 18.75C52.5 23.5825 48.5825 27.5 43.75 27.5C38.9175 27.5 35 23.5825 35 18.75C35 13.9175 38.9175 10 43.75 10Z" fill="#00A2CE" />
    </svg>

    <!-- Circle -->
    <svg
      v-else-if="name === 'circle'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        x="0.332357"
        y="0.333333"
        width="15.3333"
        height="15.3333"
        rx="7.66667"
        stroke="currentColor"
        stroke-width="0.666667"
      />
    </svg>

    <!-- Circle-checked -->
    <svg
      v-else-if="name === 'circle-checked'"
      :class="`rb-icon ${iconWidth}`"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.332357"
        y="0.999837"
        width="15.3333"
        height="15.3333"
        rx="7.66667"
        fill="#00A2CE"
        stroke="#00627C"
        stroke-width="0.666667"
      />
      <path
        d="M12.0007 6L6.5002 11.5004L4 9.00024"
        stroke="white"
        stroke-width="1.00008"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name === 'circle-checked-black'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_3930_58011)">
        <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M9.9987 0.833496C4.9362 0.833496 0.832031 4.93766 0.832031 10.0002C0.832031 15.0627 4.9362 19.1668 9.9987 19.1668C15.0612 19.1668 19.1654 15.0627 19.1654 10.0002C19.1654 4.93766 15.0612 0.833496 9.9987 0.833496ZM13.972 8.45016C14.0452 8.36653 14.1009 8.26911 14.1359 8.16364C14.1708 8.05816 14.1843 7.94676 14.1756 7.83598C14.1669 7.72521 14.1361 7.6173 14.085 7.5186C14.034 7.41991 13.9637 7.33242 13.8783 7.26128C13.793 7.19015 13.6942 7.1368 13.5879 7.10438C13.4817 7.07197 13.37 7.06113 13.2594 7.07252C13.1489 7.08391 13.0418 7.11729 12.9443 7.17069C12.8469 7.2241 12.7611 7.29645 12.692 7.3835L9.1087 11.6827L7.25453 9.82766C7.09736 9.67587 6.88686 9.59187 6.66836 9.59377C6.44987 9.59567 6.24086 9.68331 6.08635 9.83781C5.93184 9.99232 5.8442 10.2013 5.8423 10.4198C5.8404 10.6383 5.9244 10.8488 6.0762 11.006L8.5762 13.506C8.65808 13.5878 8.75611 13.6517 8.86404 13.6935C8.97198 13.7354 9.08745 13.7543 9.20309 13.749C9.31873 13.7438 9.43201 13.7145 9.53571 13.663C9.6394 13.6116 9.73124 13.5391 9.80536 13.4502L13.972 8.45016Z" fill="#151227" />
      </g>
      <defs>
        <clipPath id="clip0_3930_58011">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'circle-checked-blue'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2760_42368)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9987 0.833984C4.9362 0.833984 0.832031 4.93815 0.832031 10.0007C0.832031 15.0632 4.9362 19.1673 9.9987 19.1673C15.0612 19.1673 19.1654 15.0632 19.1654 10.0007C19.1654 4.93815 15.0612 0.833984 9.9987 0.833984ZM13.972 8.45065C14.0452 8.36702 14.1009 8.2696 14.1359 8.16412C14.1708 8.05865 14.1843 7.94725 14.1756 7.83647C14.1669 7.7257 14.1361 7.61779 14.085 7.51909C14.034 7.42039 13.9637 7.33291 13.8783 7.26177C13.793 7.19063 13.6942 7.13729 13.5879 7.10487C13.4817 7.07245 13.37 7.06162 13.2594 7.07301C13.1489 7.0844 13.0418 7.11777 12.9443 7.17118C12.8469 7.22458 12.7611 7.29694 12.692 7.38398L9.1087 11.6832L7.25453 9.82815C7.09736 9.67635 6.88686 9.59236 6.66836 9.59426C6.44987 9.59616 6.24086 9.6838 6.08635 9.8383C5.93184 9.99281 5.8442 10.2018 5.8423 10.4203C5.8404 10.6388 5.9244 10.8493 6.0762 11.0065L8.5762 13.5065C8.65808 13.5883 8.75611 13.6522 8.86404 13.694C8.97198 13.7359 9.08745 13.7548 9.20309 13.7495C9.31873 13.7443 9.43201 13.715 9.53571 13.6635C9.6394 13.6121 9.73124 13.5396 9.80536 13.4507L13.972 8.45065Z" fill="#00A2CE" />
      </g>
      <defs>
        <clipPath id="clip0_2760_42368">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'circle-checked-blue-white'"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.667969" width="20" height="20" rx="10" fill="#00A2CE" />
      <path d="M15.0008 7.33008L8.12525 14.2056L5 11.0804" stroke="white" stroke-width="1.2501" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Circle-grey-checked -->
    <svg
      v-else-if="name === 'circle-grey-checked'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="-0.00195312" width="24" height="24" rx="12" fill="white" />
      <path d="M18.6663 7L9.49967 16.1667L5.33301 12" stroke="#00A2CE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Circle-pink-checked -->
    <svg
      v-else-if="name === 'circle-pink-checked'"
      :class="`rb-icon ${iconWidth}`"
      width="59"
      height="59"
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="59" height="59" rx="29.5" fill="#3B316E" />
      <path d="M44.8644 28.0868V29.5003C44.8625 32.8136 43.7897 36.0375 41.8058 38.6912C39.822 41.3448 37.0335 43.2862 33.8562 44.2256C30.679 45.165 27.2831 45.0522 24.1752 43.904C21.0673 42.7558 18.4138 40.6337 16.6104 37.8542C14.8071 35.0747 13.9506 31.7867 14.1686 28.4806C14.3866 25.1745 15.6674 22.0275 17.8201 19.5089C19.9728 16.9902 22.882 15.2349 26.1138 14.5047C29.3456 13.7745 32.7268 14.1086 35.7532 15.4571" stroke="#E71C77" stroke-width="3.07292" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M44.8646 17.209L29.5 32.5889L24.8906 27.9796" stroke="#E71C77" stroke-width="3.07292" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Box -->
    <svg
      v-else-if="name === 'box'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        stroke="#A2A3A4"
      />
    </svg>

    <!-- Check -->
    <svg
      v-else-if="name === 'check'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 6L9 17L4 12"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Box-checked -->
    <svg
      v-else-if="name === 'box-checked'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 348">
        <rect
          id="Rectangle 216"
          width="24"
          height="24"
          rx="4"
          fill="#0FBA80"
        />
        <g id="Icon / check">
          <path
            id="Vector"
            d="M20 6L9 17L4 12"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>

    <!-- dead-bird -->
    <svg
      v-else-if="name === 'dead-bird'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 71.467 89.33125000000001"
      xml:space="preserve"
    ><path
      fill="currentColor"
      d="M67.503,32.314l1.621-10.395l-9.166,5.067l-5.067-3.543c-0.022-0.016-0.046-0.03-0.068-0.047  c-12.56-8.726-29.817-5.654-38.587,6.888C11.601,36.913,0.368,52.977,0.329,53.032c0,0,59.784-0.028,59.889-0.029  c0.04,0,0.081-0.008,0.121-0.011c1.47-0.03,2.919-0.349,4.278-0.919c1.394-0.585,2.685-1.441,3.786-2.555  c0.453-0.458,0.877-0.956,1.26-1.502c0.377-0.541,0.688-1.104,0.964-1.679C72.915,41.544,71.671,35.734,67.503,32.314z   M57.667,42.778l-1.511,1.509l-2.279-2.279l-2.28,2.279l-1.509-1.509l2.28-2.28l-2.28-2.279l1.509-1.51l2.28,2.279l2.279-2.279  l1.511,1.51l-2.28,2.279L57.667,42.778z"
    /></svg>

    <svg
      v-else-if="name === 'cross-red-circle'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_681_10821)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9987 0.833008C4.9362 0.833008 0.832031 4.93717 0.832031 9.99967C0.832031 15.0622 4.9362 19.1663 9.9987 19.1663C15.0612 19.1663 19.1654 15.0622 19.1654 9.99967C19.1654 4.93717 15.0612 0.833008 9.9987 0.833008ZM13.0879 8.08884C13.2397 7.93167 13.3237 7.72117 13.3218 7.50267C13.3199 7.28418 13.2322 7.07517 13.0777 6.92066C12.9232 6.76615 12.7142 6.67851 12.4957 6.67661C12.2772 6.67471 12.0667 6.75871 11.9095 6.91051L9.9987 8.82134L8.08786 6.91051C8.01099 6.83092 7.91904 6.76743 7.81737 6.72376C7.7157 6.68008 7.60635 6.65709 7.4957 6.65613C7.38505 6.65517 7.27532 6.67626 7.1729 6.71816C7.07049 6.76006 6.97745 6.82194 6.8992 6.90018C6.82096 6.97842 6.75908 7.07147 6.71718 7.17388C6.67528 7.27629 6.65419 7.38603 6.65516 7.49668C6.65612 7.60733 6.67911 7.71668 6.72278 7.81835C6.76645 7.92001 6.82994 8.01197 6.90953 8.08884L8.82037 9.99967L6.90953 11.9105C6.82994 11.9874 6.76645 12.0793 6.72278 12.181C6.67911 12.2827 6.65612 12.392 6.65516 12.5027C6.65419 12.6133 6.67528 12.7231 6.71718 12.8255C6.75908 12.9279 6.82096 13.0209 6.8992 13.0992C6.97745 13.1774 7.07049 13.2393 7.1729 13.2812C7.27532 13.3231 7.38505 13.3442 7.4957 13.3432C7.60635 13.3423 7.7157 13.3193 7.81737 13.2756C7.91904 13.2319 8.01099 13.1684 8.08786 13.0888L9.9987 11.178L11.9095 13.0888C12.0667 13.2406 12.2772 13.3246 12.4957 13.3227C12.7142 13.3208 12.9232 13.2332 13.0777 13.0787C13.2322 12.9242 13.3199 12.7152 13.3218 12.4967C13.3237 12.2782 13.2397 12.0677 13.0879 11.9105L11.177 9.99967L13.0879 8.08884Z" fill="#EF4444" />
      </g>
      <defs>
        <clipPath id="clip0_681_10821">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'check-green-circle-alternative'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3930_60989)">
        <rect width="24" height="24" rx="4" fill="#0FBA80" />
        <path d="M18 7.5L9.75 15.75L6 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3930_60989">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'check-green-circle'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_681_10851)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9987 0.833496C4.9362 0.833496 0.832031 4.93766 0.832031 10.0002C0.832031 15.0627 4.9362 19.1668 9.9987 19.1668C15.0612 19.1668 19.1654 15.0627 19.1654 10.0002C19.1654 4.93766 15.0612 0.833496 9.9987 0.833496ZM13.972 8.45016C14.0452 8.36653 14.1009 8.26911 14.1359 8.16364C14.1708 8.05816 14.1843 7.94676 14.1756 7.83598C14.1669 7.72521 14.1361 7.6173 14.085 7.5186C14.034 7.41991 13.9637 7.33242 13.8783 7.26128C13.793 7.19015 13.6942 7.1368 13.5879 7.10438C13.4817 7.07197 13.37 7.06113 13.2594 7.07252C13.1489 7.08391 13.0418 7.11729 12.9443 7.17069C12.8469 7.2241 12.7611 7.29645 12.692 7.3835L9.1087 11.6827L7.25453 9.82766C7.09736 9.67587 6.88686 9.59187 6.66836 9.59377C6.44987 9.59567 6.24086 9.68331 6.08635 9.83781C5.93184 9.99232 5.8442 10.2013 5.8423 10.4198C5.8404 10.6383 5.9244 10.8488 6.0762 11.006L8.5762 13.506C8.65808 13.5878 8.75611 13.6517 8.86404 13.6935C8.97198 13.7354 9.08745 13.7543 9.20309 13.749C9.31873 13.7438 9.43201 13.7145 9.53571 13.663C9.6394 13.6116 9.73124 13.5391 9.80536 13.4502L13.972 8.45016Z" fill="#0FBA80" />
      </g>
      <defs>
        <clipPath id="clip0_681_10851">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'logout'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.3333 14.1666L17.5 9.99992L13.3333 5.83325" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17.5 10H7.5" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'minus'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'plus'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 5V19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'plus-square'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19.5 3H5.5C4.39543 3 3.5 3.89543 3.5 5V19C3.5 20.1046 4.39543 21 5.5 21H19.5C20.6046 21 21.5 20.1046 21.5 19V5C21.5 3.89543 20.6046 3 19.5 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.5 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.5 12H16.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'thumbs-up'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg
      v-else-if="name === 'apple'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M20.4518 7.82836C20.3534 7.88996 18.011 9.18996 18.011 12.0724C18.1214 15.3596 20.967 16.5124 21.0158 16.5124C20.967 16.574 20.5862 18.0828 19.4582 19.6644C18.563 21.0268 17.5694 22.4004 16.0606 22.4004C14.6254 22.4004 14.1102 21.4924 12.4542 21.4924C10.6758 21.4924 10.1726 22.4004 8.81104 22.4004C7.30224 22.4004 6.23504 20.9532 5.29104 19.6036C4.06464 17.8372 3.02224 15.0652 2.98544 12.4036C2.96064 10.9932 3.23104 9.60676 3.91744 8.42916C4.88624 6.78516 6.61584 5.66916 8.50464 5.63236C9.95184 5.58356 11.2398 6.62596 12.123 6.62596C12.9694 6.62596 14.5518 5.63236 16.3422 5.63236C17.115 5.63316 19.1758 5.86596 20.4518 7.82836ZM12.0006 5.35076C11.743 4.06276 12.4542 2.77476 13.1166 1.95316C13.963 0.959556 15.2998 0.285156 16.4526 0.285156C16.5262 1.57316 16.0598 2.83636 15.2262 3.75636C14.4782 4.74996 13.1902 5.49796 12.0006 5.35076Z" fill="white" />
    </svg>
    <svg
      v-else-if="name === 'thumbs-down'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.9991 2.00036H19.6691C20.235 1.99035 20.785 2.1885 21.2145 2.55718C21.644 2.92586 21.9232 3.43942 21.9991 4.00036V11.0004C21.9232 11.5613 21.644 12.0749 21.2145 12.4435C20.785 12.8122 20.235 13.0104 19.6691 13.0004H16.9991M9.99905 15.0004V19.0004C9.99905 19.796 10.3151 20.5591 10.8777 21.1217C11.4403 21.6843 12.2034 22.0004 12.9991 22.0004L16.9991 13.0004V2.00036H5.71905C5.23673 1.99491 4.76868 2.16396 4.40115 2.47636C4.03362 2.78875 3.79138 3.22346 3.71905 3.70036L2.33905 12.7004C2.29555 12.987 2.31488 13.2797 2.39571 13.5581C2.47655 13.8365 2.61695 14.0941 2.8072 14.3128C2.99744 14.5316 3.23297 14.7064 3.49748 14.8251C3.76199 14.9439 4.04915 15.0036 4.33905 15.0004H9.99905Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'android'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M7.7422 1.21225C7.66962 1.21392 7.59887 1.23531 7.53752 1.27412C7.47617 1.31293 7.42654 1.36771 7.39394 1.43258C7.36135 1.49745 7.34702 1.56996 7.35249 1.64235C7.35797 1.71474 7.38303 1.78427 7.42501 1.8435L8.60782 3.55288C7.47215 4.42319 6.67671 5.71609 6.46407 7.19975H17.5359C17.3233 5.71609 16.5279 4.42319 15.3922 3.55288L16.575 1.8435C16.6176 1.78341 16.6427 1.71273 16.6477 1.63926C16.6527 1.56578 16.6372 1.49236 16.6032 1.42709C16.5691 1.36181 16.5176 1.30721 16.4545 1.26931C16.3913 1.2314 16.319 1.21166 16.2453 1.21225C16.1804 1.21285 16.1166 1.22924 16.0595 1.26C16.0023 1.29076 15.9535 1.33497 15.9172 1.38882L14.725 3.11382C13.9186 2.66194 12.991 2.39975 12 2.39975C11.009 2.39975 10.0814 2.66194 9.27501 3.11382L8.08282 1.38882C8.04539 1.3332 7.99458 1.28789 7.93506 1.25704C7.87554 1.22618 7.80922 1.21079 7.7422 1.21225ZM9.60001 3.99975C10.0416 3.99975 10.4 4.35815 10.4 4.79975C10.4 5.24135 10.0416 5.59975 9.60001 5.59975C9.15841 5.59975 8.80001 5.24135 8.80001 4.79975C8.80001 4.35815 9.15841 3.99975 9.60001 3.99975ZM14.4 3.99975C14.8416 3.99975 15.2 4.35815 15.2 4.79975C15.2 5.24135 14.8416 5.59975 14.4 5.59975C13.9584 5.59975 13.6 5.24135 13.6 4.79975C13.6 4.35815 13.9584 3.99975 14.4 3.99975ZM4.00001 8.79975C3.55841 8.79975 3.20001 9.15815 3.20001 9.59975V15.9998C3.20001 16.4414 3.55841 16.7998 4.00001 16.7998C4.44161 16.7998 4.80001 16.4414 4.80001 15.9998V9.59975C4.80001 9.15815 4.44161 8.79975 4.00001 8.79975ZM6.40001 8.79975V16.7998C6.40001 17.6838 7.11601 18.3998 8.00001 18.3998V21.1998C8.00001 21.8622 8.53761 22.3998 9.20001 22.3998C9.86241 22.3998 10.4 21.8622 10.4 21.1998V18.3998H13.6V21.1998C13.6 21.8622 14.1376 22.3998 14.8 22.3998C15.4624 22.3998 16 21.8622 16 21.1998V18.3998C16.884 18.3998 17.6 17.6838 17.6 16.7998V8.79975H6.40001ZM20 8.79975C19.5584 8.79975 19.2 9.15815 19.2 9.59975V15.9998C19.2 16.4414 19.5584 16.7998 20 16.7998C20.4416 16.7998 20.8 16.4414 20.8 15.9998V9.59975C20.8 9.15815 20.4416 8.79975 20 8.79975Z" fill="white" />
    </svg>

    <svg
      v-else-if="name === 'check-circle'"
      :class="`rb-icon ${iconWidth}`"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_681_10775)">
        <path d="M14.6663 7.3865V7.99983C14.6655 9.43744 14.2 10.8363 13.3392 11.9877C12.4785 13.1391 11.2685 13.9815 9.88991 14.3891C8.5113 14.7967 7.03785 14.7478 5.68932 14.2496C4.3408 13.7513 3.18944 12.8306 2.40698 11.6245C1.62452 10.4185 1.25287 8.99187 1.34746 7.55737C1.44205 6.12287 1.99781 4.75738 2.93186 3.66454C3.86591 2.57171 5.1282 1.81008 6.53047 1.49326C7.93274 1.17643 9.39985 1.32139 10.713 1.9065" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.6667 2.66675L8 9.34008L6 7.34008" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_681_10775">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'warning-triangle'"
      :class="`rb-icon ${iconWidth}`"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_681_10775)">
        <path d="M14.6663 7.3865V7.99983C14.6655 9.43744 14.2 10.8363 13.3392 11.9877C12.4785 13.1391 11.2685 13.9815 9.88991 14.3891C8.5113 14.7967 7.03785 14.7478 5.68932 14.2496C4.3408 13.7513 3.18944 12.8306 2.40698 11.6245C1.62452 10.4185 1.25287 8.99187 1.34746 7.55737C1.44205 6.12287 1.99781 4.75738 2.93186 3.66454C3.86591 2.57171 5.1282 1.81008 6.53047 1.49326C7.93274 1.17643 9.39985 1.32139 10.713 1.9065" stroke="#0FBA80" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.6667 2.66675L8 9.34008L6 7.34008" stroke="#0FBA80" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_681_10775">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'check-circle-white'"
      :class="`rb-icon ${iconWidth}`"
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M32.0833 16.6582V17.9999C32.0815 21.1447 31.0632 24.2046 29.1802 26.7234C27.2973 29.2421 24.6506 31.0847 21.6349 31.9764C18.6191 32.8681 15.396 32.761 12.4461 31.6712C9.49616 30.5813 6.97758 28.5671 5.26594 25.9289C3.55431 23.2908 2.74132 20.17 2.94824 17.032C3.15515 13.894 4.37089 10.907 6.41412 8.51645C8.45735 6.12587 11.2186 4.45982 14.2861 3.76676C17.3535 3.07371 20.5628 3.39079 23.4354 4.67072" stroke="white" stroke-width="2.91667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M32.0833 6.3335L17.5 20.9314L13.125 16.5564" stroke="white" stroke-width="2.91667" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <clipPath id="clip0_681_10775">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'play'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >

      <path
        d="M4.24994 2.62793L14.7498 9.37784L4.24994 16.1277V2.62793Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.49998"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name === 'play-outline'"
      :class="`rb-icon ${iconWidth}`"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.75 3L19.75 12L5.75 21V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'pause-outline'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <rect x="14" y="3" width="5" height="18" rx="1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="5" y="3" width="5" height="18" rx="1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Trending up -->
    <svg
      v-else-if="name === 'trending-up'"
      :class="`rb-icon ${iconWidth}`"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="Icon / trending-up" clip-path="url(#clip0_4053_14882)">
        <path
          id="Vector"
          d="M23.5 6L14 15.5L9 10.5L1.5 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M17.5 6H23.5V12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4053_14882">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>

    </svg>

    <!-- Chevron up -->

    <svg
      v-else-if="name === 'chevron-up'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 15L12 9L6 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Chevron down -->

    <svg
      v-else-if="name === 'chevron-down'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 9L12 15L18 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Chevron up -->

    <svg
      v-else-if="name === 'chevron-up-color'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Chevron down -->

    <svg
      v-else-if="name === 'chevron-down-color'"
      :class="`rb-icon ${iconWidth}`"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- download icon -->
    <svg
      v-else-if="name === 'download'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon / download">
        <path
          id="Vector"
          d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
          stroke="#00A2CE"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M5.83203 8.3335L9.9987 12.5002L14.1654 8.3335"
          stroke="#00A2CE"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M10 12.5V2.5"
          stroke="#00A2CE"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>

    <svg
      v-else-if="name === 'folder-plus'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 14H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'folder-minus'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 14H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name === 'zap'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  </span>
</template>
